export function normalizeRoute(segment: string) {
  if (segment) {
    const contentWithoutLeadingSlash = segment.replace(/^\/+/, '');

    const endsWithSlash = contentWithoutLeadingSlash.endsWith('/');

    const segmentsNormalized = contentWithoutLeadingSlash
      .split('/')
      .filter(Boolean)
      .map((seg) =>
        seg
          .toLowerCase()
          .replace(/\s+/g, '-')
          .replace(/[^a-z0-9-]/g, '')
      )
      .join('/');

    return endsWithSlash && segmentsNormalized ? `${segmentsNormalized}/` : segmentsNormalized;
  }

  return '';
}
